import visa from './images/visa.inline.svg';
import mastercard from './images/mastercard.inline.svg';
import maestro from './images/maestro.inline.svg';
import discovercard from './images/discovercard.inline.svg';
import americanexpress from './images/amex.inline.svg';
import dinersclub from './images/dinersclub.inline.svg';
import jcpenney from './images/jcpenney.inline.svg';
import ulta from './images/ulta.inline.svg';
import nordstrom from './images/nordstrom.inline.svg';

export const VISA = 'visa';
export const MASTERCARD = 'mastercard';
export const DISCOVER = 'discovercard';
export const AMEX = 'americanexpress';
export const DINERS = 'dinersclub';
export const JCP = 'jcpenney';
export const ULTA = 'ulta';
export const NORDSTROM = 'nordstrom';
export const MAESTRO = 'maestro';

export const creditCardImageDict = {
    [AMEX]: americanexpress,
    [DINERS]: dinersclub,
    [DISCOVER]: discovercard,
    [JCP]: jcpenney,
    [MAESTRO]: maestro,
    [MASTERCARD]: mastercard,
    [NORDSTROM]: nordstrom,
    [ULTA]: ulta,
    [VISA]: visa
};


export const creditCardImageList = [
    {
        type: VISA,
        url: visa,
        alt: VISA,
    },
    {
        type: MASTERCARD,
        url: mastercard,
        alt: MASTERCARD,
    },
    {
        type: MAESTRO,
        url: maestro,
        alt: MAESTRO,
    },
    {
        type: DISCOVER,
        url: discovercard,
        alt: DISCOVER,
    },
    {
        type: AMEX,
        url: americanexpress,
        alt: AMEX,
    },
    {
        type: DINERS,
        url: dinersclub,
        alt: DINERS,
    },
    {
        type: JCP,
        url: jcpenney,
        alt: JCP,
    },
    {
        type: ULTA,
        url: ulta,
        alt: ULTA,
    },
    {
        type: NORDSTROM,
        url: nordstrom,
        alt: NORDSTROM,
    },
];
